import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import '../../services/GlobalVariables'
import authService from './authService'

const API_URL = global.SET_API_URL + "users/"

const user = JSON.parse(localStorage.getItem('user'))

const initialState = {
    user: user ? user : null,
    allUsers: [],
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: ""
}

export const register = createAsyncThunk('auth/register', async (user, thunkAPI) => {
    try {

        return await authService.register(user)
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const login = createAsyncThunk('auth/login', async (user, thunkAPI) => {
    try {
        const systemInfo = typeof window !== 'undefined' ? {
            platform: window.navigator?.userAgentData?.platform || window.navigator?.platform || '',
            screenResolution: window.screen ? `${window.screen.width}x${window.screen.height}` : '',
            timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || '',
            language: window.navigator?.language || ''
        } : {}
        const response = await axios.post(API_URL + 'loginUser', { ...user, systemInfo })
        const payload = { ...response.data }

        // Normalize company fields for UI (logo/name)
        if (payload.company) {
            payload.cmpName = payload.company.cmpName
            payload.cmpImage = payload.company.cmpImage
        }

        if (payload.message && payload.message.includes('successful')) {
            // Login successful - store user with branch info
            localStorage.setItem('user', JSON.stringify(payload))
            return payload
        } else if (payload.message && !payload.message.includes('successful')) {
            // Login failed
            return thunkAPI.rejectWithValue(payload.message)
        } else {
            // Old response format - store as is
            localStorage.setItem('user', JSON.stringify(payload))
            return payload
        }

    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const getAllUsers = createAsyncThunk('auth/gau', async (cmpID, thunkAPI) => {
    try {
        const response = await axios.post(API_URL + 'getAllUsers', cmpID)
        return response.data

    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const logOut = createAsyncThunk('auth/logout', async (navigate) => {
    localStorage.removeItem('user')
    navigate('/Login')
})

export const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        reset: (state) => {
            state.isLoading = false
            state.isError = false
            state.isSuccess = false
            state.message = ""
            state.user = null
        },
        switchBranch: (state, action) => {
            if (!state.user) return
            const branchID = Number(action.payload)
            const selected = (state.user.allowedBranches || []).find((branch) => Number(branch.branchID) === branchID)
            if (!selected) return
            state.user.defaultBranchID = branchID
            state.user.assignedCounterId = selected.counterID || null
            state.user.branchID = branchID
            state.user.branch = { branchID, branchCode: selected.branchCode || null, branchName: selected.branchName || null }
            localStorage.setItem('user', JSON.stringify(state.user))
        }

    },
    extraReducers: (builder) => {
        builder
            .addCase(register.pending, (state) => {
                state.isLoading = true
            })
            .addCase(register.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.user = action.payload
            })
            .addCase(register.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
                state.user = null
            })
            .addCase(login.pending, (state) => {
                state.isLoading = true
            })
            .addCase(login.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                if (action.payload === "User's License Is Not Expired!...") {
                    console.log('Done')
                }
                state.user = action.payload
            })
            .addCase(login.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
                state.user = null
            })
            .addCase(getAllUsers.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getAllUsers.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.allUsers = action.payload
            })
            .addCase(getAllUsers.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
                state.allUsers = null
            })
            .addCase(logOut.fulfilled, (state) => {
                state.user = null
            })
    }
})

export const { reset, switchBranch } = authSlice.actions

export default authSlice.reducer
